import { render, staticRenderFns } from "./ITservice.vue?vue&type=template&id=756937ec&"
import script from "./ITservice.vue?vue&type=script&lang=ts&"
export * from "./ITservice.vue?vue&type=script&lang=ts&"
import style0 from "./ITservice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports